import { ApiError } from '@/lib/api/http-client'

type AuthTranslator = (key: string) => string

const credentialsErrorMessages = new Set([
  'email or password incorrect',
  'please check credentials, login failed',
])

// 后端稳定 error_code 到本地化文案 key 的映射；message 兼容只服务旧响应。
const loginErrorCodeMap: Record<string, string> = {
  'auth.account_unavailable': 'common.loginError.accountUnavailable',
  'auth.credentials_invalid': 'common.loginError.credentialsInvalid',
  'auth.email_password_disabled': 'common.loginError.emailPasswordDisabled',
  'auth.missing_credentials': 'common.loginError.generic',
}

/**
 * 将登录接口错误转换为面向用户的本地化文案。
 * 优先使用后端稳定 error_code；英文 message 只作为旧响应兼容兜底。
 */
export function resolveLoginErrorMessage(error: unknown, t: AuthTranslator) {
  if (!(error instanceof ApiError)) {
    return t('common.networkError')
  }

  return resolveLoginFailureMessage(error.message, t, error.status, error.errorCode)
}

export function resolveLoginFailureMessage(
  message: string | undefined,
  t: AuthTranslator,
  status?: number,
  errorCode?: string,
) {
  if (errorCode && loginErrorCodeMap[errorCode]) {
    return t(loginErrorCodeMap[errorCode])
  }

  const normalizedMessage = message?.trim().toLowerCase()

  // 登录失败文案不能区分账号不存在和密码错误，避免账号枚举。
  if (normalizedMessage && credentialsErrorMessages.has(normalizedMessage)) {
    return t('common.loginError.credentialsInvalid')
  }

  if (normalizedMessage === 'email password login is not enabled') {
    return t('common.loginError.emailPasswordDisabled')
  }

  if (normalizedMessage === 'account is not available') {
    return t('common.loginError.accountUnavailable')
  }

  if (status && status >= 500) {
    return t('common.loginError.serviceUnavailable')
  }

  return t('common.loginError.generic')
}
